module.exports = __webpack_public_path__ + "static/media/RecentWork.46aed943.png";